<template>
  <v-container grid-list-md fluid>
    <h2>カレンダー管理</h2>
    <v-layout align-center justify-start row fill-height>
      <v-flex md2>
        <v-select :items="years" v-model="year" suffix="年" />
      </v-flex>
      <v-flex md1>
        <v-select :items="months" v-model="month" suffix="月" />
      </v-flex>
    </v-layout>
    <v-layout row align-center>
      <v-flex md4>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-flex>
    </v-layout>

    <v-spacer></v-spacer>
    <v-dialog v-model="dialog">
      <edit-item
        v-if="dialog"
        @closeDialog="closeDialog"
        @updateItem="updateItem"
        v-model="selectedItem"
        :action="action"
      />
      <v-alert :value="errorMessage.length>0">{{errorMessage}}</v-alert>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      id="calendar-table"
      :pagination.sync="pagination"
      rows-per-page-text="表示行"
    >
      <template slot="items" slot-scope="props">
        <tr @click="editItem(props.item)">
          <td class="text-xs-left" :class="dayClass(props.item)">{{props.item.date}}</td>
          <td class="text-xs-left" :class="dayClass(props.item)">{{props.item.day}}</td>
          <td class="text-xs-left">{{props.item.holiday_name}}</td>
          <td>
            <v-btn icon @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>

      <template
        slot="pageText"
        slot-scope="props"
      >{{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示</template>
    </v-data-table>
    <v-card id="adding-one-year-card">
      <v-card-text>
        <h3>年間カレンダーの追加</h3>
        <v-layout row align-center>
          <v-flex md3>
            <v-select :items="years" v-model="year" label="年"></v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="confirmAddingDates">
          <v-icon>add</v-icon>追加
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="confirmDialog" max-width="500px">
      <v-card>
        <v-card-title>日時を上書き</v-card-title>
        <v-card-text>
          {{year}}のカレンダーを追加します。追加されている場合は上書きします。
          追加を実施しますか？
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="confirmDialog=false">キャンセル</v-btn>
          <v-btn color="primary" flat @click="confirmDialog=false; addOneYearsDates();">追加</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import auth from "@/components/fireAuthInit";
import EditItem from "@/components/Calendar/editDate.vue";
import firebase from "firebase";
import XLSX from "xlsx";
import JapaneseHolidays from "japanese-holidays";
import { mapGetters, mapState, mapMutations } from "vuex";

var moment = require("moment-timezone");
moment.tz.setDefault("Asia/Tokyo");
const dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"];
export default {
  components: {
    EditItem
  },
  data() {
    return {
      years: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      year: 2019,
      month: 4,
      dates: [],
      items: [],
      dbRef: db.collection("calendar"),
      action: "add",
      dialog: false,
      selectedItem: {},
      newItem: { id: "", name: "" },
      errorMessage: "",
      promises: [],
      headers: [
        { text: "日", value: "date", sortable: false, width: "3%" },
        { text: "曜日", value: "day", sortable: false, width: "3%" },
        { text: "何の日", sortable: false, width: "10%" },
        { text: "操作", sortable: false, width: "10%" }
      ],
      file: null,
      pagination: {
        rowsPerPage: 50
      },
      search: "",
      confirmDialog: false
    };
  },
  computed: {
    monthId() {
      return String(this.year) + "-" + ("00" + this.month).slice(-2);
    }
  },
  watch: {
    monthId() {
      this.reloadItems();
    }
  },
  mounted() {
    this.reloadItems();
  },
  methods: {
    async reloadItems() {
      this.changeLoadingState(true);
      this.items = [];
      const items = await this.dbRef
        .doc(this.monthId)
        .collection("dates")
        .get();
      items.forEach(doc => {
        this.items.push({ ...doc.data(), id: doc.id });
      });
      this.changeLoadingState(false);
    },
    closeDialog() {
      this.errorMessage = "";
      this.dialog = false;
    },
    editItem(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.action = "update";
      this.dialog = true;
    },
    confirmAddingDates() {
      this.confirmDialog = true;
    },
    async addOneYearsDates() {
      this.changeLoadingState(true);
      const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      months.forEach(m => {
        let date = moment([this.year, m - 1, 1]);
        const dates = [];
        const id = date.format("YYYY-MM");
        while (date.month() + 1 == m) {
          dates.push({
            year: this.year,
            month: m,
            date: date.date(),
            day_number: date.day(),
            day: dayOfWeekStr[date.day()],
            is_holiday: JapaneseHolidays.isHoliday(date.toDate())
              ? true
              : false,
            holiday_name: JapaneseHolidays.isHoliday(date.toDate())
              ? JapaneseHolidays.isHoliday(date.toDate())
              : "",
            id: date.format("YYYY-MM-DD")
          });
          date.add(1, "day");
        }
        this.createItems(dates, id);
      });
      await Promise.all(this.promises);
      this.changeLoadingState(false);
    },
    async updateItem() {
      await this.dbRef
        .doc(this.monthId)
        .collection("dates")
        .doc(this.selectedItem.id)
        .set(this.selectedItem);
      this.closeDialog();
      this.reloadItems();
    },
    selectedFile(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },
    importFile() {
      this.changeLoadingState(true);
      const reader = new FileReader();
      reader.readAsArrayBuffer(this.file);
      reader.onload = e => {
        const data = new Uint8Array(reader.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const items = XLSX.utils.sheet_to_json(worksheet);
        this.createItems(items);
      };
    },
    async createItems(items, id) {
      const promises = [];
      try {
        items.forEach(item => {
          const p = this.dbRef
            .doc(id)
            .collection("dates")
            .doc(item.id)
            .set(item);
          this.promises.push(p);
        });
      } catch (e) {
        console.errro(e);
      }
    },
    dayClass(d) {
      if (d.day_number == 0 || d.is_holiday) {
        return { holiday: true };
      } else if (d.day_number == 6) {
        return { saturday: true };
      }
    },
    prvMonth() {
      this.month = this.month - 1;
    },
    nextMonth() {
      this.month = this.month + 1;
    },
    ...mapMutations("app", ["changeLoadingState"])
  },
  created: function() {}
};
</script>
<style lang="scss" scoped>
div.pageTitle {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
div.yearMonth {
  display: inline-block;
  font-size: 20px;
  /* color: #ddd; */
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
  text-align: center;
}
.align-right {
  text-align: right;
}
td.holiday {
  color: #f44336;
}
td.saturday {
  color: #2196f3;
}
#calendar-table {
  width: 50%;
}
#adding-one-year-card {
  width: 30%;
  margin: 10px 0px;
}
</style>